import { render, staticRenderFns } from "./exportpickup.vue?vue&type=template&id=036561c2"
import script from "./exportpickup.vue?vue&type=script&lang=js"
export * from "./exportpickup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports